import request from '@/utils/request'


// 查询余额充值模板列表
export function listTemplate(query) {
  return request({
    url: '/balance/template/list',
    method: 'get',
    params: query
  })
}

// 查询余额充值模板分页
export function pageTemplate(query) {
  return request({
    url: '/balance/template/page',
    method: 'get',
    params: query
  })
}

// 查询余额充值模板详细
export function getTemplate(data) {
  return request({
    url: '/balance/template/detail',
    method: 'get',
    params: data
  })
}

// 新增余额充值模板
export function addTemplate(data) {
  return request({
    url: '/balance/template/add',
    method: 'post',
    data: data
  })
}

// 修改余额充值模板
export function updateTemplate(data) {
  return request({
    url: '/balance/template/edit',
    method: 'post',
    data: data
  })
}

// 删除余额充值模板
export function delTemplate(data) {
  return request({
    url: '/balance/template/delete',
    method: 'post',
    data: data
  })
}
